import { render } from "./user-card.vue?vue&type=template&id=731ddc2e&scoped=true"
import script from "./user-card.vue?vue&type=script&lang=js"
export * from "./user-card.vue?vue&type=script&lang=js"

import "./user-card.vue?vue&type=style&index=0&id=731ddc2e&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-731ddc2e"]])

export default __exports__